import { useSearchParams } from "react-router-dom";
import { Button } from "@components/Button/Button";
import { RenderImg } from "@components/RenderIcon/RenderImg";
import HoorayIcon from "@assets/images/Hooray.svg";
import { useTranslation } from "react-i18next";
import { Wrapper, InfoWrapper, IconWrapper, ButtonWrapper } from "./component";
import { TopicStyle, DescStyle } from "./style";
import { onPostMsgToGrab } from "./functional";
import liff from "@line/liff";
import { useEffect } from "react";
import { useAuthContext } from "@providers/AuthProvider";
import { removeLS } from "@utils";
import { LS_AUTH } from "@configs";

export const MappingSuccessPage: React.FC = () => {
  const { t, i18n } = useTranslation();
  const [queryParameters] = useSearchParams();
  const { authorizeState } = useAuthContext();

  const lang = queryParameters.get("lang");

  useEffect(() => {
    if (lang !== null)
      i18n.changeLanguage(lang, (err) => {
        if (!err) {
          localStorage.setItem("preferredLanguage", lang);
        }
      });
  }, [lang]);

  return (
    <Wrapper>
      <IconWrapper>
        <RenderImg
          src={HoorayIcon}
          alt="hooray"
          width={"70%"}
          height={"auto"}
        />
      </IconWrapper>
      <InfoWrapper>
        <TopicStyle className="text-center">
          {t("status.mapping.success.topic")}
        </TopicStyle>
        <DescStyle className="text-center">
          {t("status.mapping.success.desc")}
        </DescStyle>
        <ButtonWrapper>
          <Button
            variant="success"
            onClick={() => {
              liff.closeWindow();
              onPostMsgToGrab({
                msg: `DATA:{"login_method": "${
                  authorizeState?.loginMethod ?? "APP"
                }"}`,
              });
              onPostMsgToGrab({
                msg: "SUCCESS:LINK_SUCCESS",
              });
              removeLS(LS_AUTH);
            }}>
            {t("button.close")}
          </Button>
        </ButtonWrapper>
      </InfoWrapper>
    </Wrapper>
  );
};
